import React from 'react';

import { Prize } from '../../types/game'; // Updated import path to use types/game
import { useSettingsRedux } from '../../hooks/useSettingsRedux';
import { getPrizeAmount } from '../../constants/gameConfig';
import './PrizeCard.css';

export interface PrizeCardProps {
  prize: Prize;
  onClick: (prizeId: string, event: React.MouseEvent<HTMLElement>) => void; // Changed MouseEvent type
}

const PrizeCard: React.FC<PrizeCardProps> = ({ prize, onClick }) => {
  const { settings } = useSettingsRedux();

  // Get dynamic prize amount from settings
  const prizeAmount = getPrizeAmount(settings);

  const getCollectableName = () => {
    if (settings?.translations?.feed?.collectable?.name) {
      return settings.translations.feed.collectable.name;
    }
    return 'Prize'; // Fallback
  };

  const getCollectableButton = () => {
    if (settings?.translations?.feed?.collectable?.button) {
      return settings.translations.feed.collectable.button;
    }
    return prize.title; // Fallback to prize title
  };

  const labelText = getCollectableButton();
  const valueText = `€${prizeAmount}`;

  return (
    <div
      className={`playmerce-card playmerce-prize-card ${prize.claimed ? 'claimed' : ''}`}
      onClick={(e) => !prize.claimed && onClick(prize.id, e)}
    >
      <div className="card-content">
        <div className="product-stack">
          <div className="prize-image-container">
            <img src={prize.imageUrl} alt={prize.title} className="prize-image" />
          </div>
          <h3 className="prize-title">{getCollectableName()}</h3>
          <button className="prize-collect-button">
            <span className="collect-label">{labelText}</span>
            <span className="collect-value">{valueText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrizeCard;
